import { __assign, __decorate, __extends, __rest } from "tslib";
/**
 * This component uses the rc-slider module
 * https://www.npmjs.com/package/rc-slider
 */
import React from 'react';
import { observer } from 'mobx-react';
import { Misc } from '@singularsystems/neo-core';
import { NeoReactTypes } from '../Modules/Types';
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sliderImplementation = Misc.Globals.appService.get(NeoReactTypes.Components.Slider);
        _this.rangeImplementation = Misc.Globals.appService.get(NeoReactTypes.Components.Range);
        _this.onChangeHandler = function (value) {
            if (!(value instanceof Array)) {
                // This is a <Slider/>
                _this.props.bind.value = value;
            }
            else if (_this.isRange) {
                // This is a <Range />
                _this.props.bind.value = value[0];
                _this.rangeProps.bindEnd.value = value[1];
            }
            // Check if there is a custom onChangeEvent prop
            if (_this.props.onChangeEvent) {
                _this.props.onChangeEvent();
            }
        };
        return _this;
    }
    Object.defineProperty(Slider.prototype, "isRange", {
        get: function () {
            return this.props.bindEnd !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slider.prototype, "rangeProps", {
        get: function () {
            return this.props;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slider.prototype, "sliderProps", {
        get: function () {
            return this.props;
        },
        enumerable: false,
        configurable: true
    });
    Slider.prototype.getSlider = function () {
        var _a = this.sliderProps, bind = _a.bind, onChangeEvent = _a.onChangeEvent, other = __rest(_a, ["bind", "onChangeEvent"]);
        other.defaultValue = bind.value;
        other.value = bind.value;
        return React.createElement(this.sliderImplementation, __assign({}, other, { onChange: this.onChangeHandler }));
    };
    Slider.prototype.getRange = function () {
        var _a = this.rangeProps, bind = _a.bind, bindEnd = _a.bindEnd, onChangeEvent = _a.onChangeEvent, other = __rest(_a, ["bind", "bindEnd", "onChangeEvent"]);
        other.defaultValue = [bind.value, bindEnd.value];
        other.value = [bind.value, bindEnd.value];
        return React.createElement(this.rangeImplementation, __assign({}, other, { onChange: this.onChangeHandler }));
    };
    Slider.prototype.render = function () {
        return (React.createElement("div", { className: "Slider" },
            this.isRange && this.getRange(),
            !this.isRange && this.getSlider()));
    };
    Slider = __decorate([
        observer
    ], Slider);
    return Slider;
}(React.Component));
export default Slider;
